<template>
  <section id="compose-a-view" class="view-compose-invitation" aria-labelledby="view-compose-title">
    <div class="view-compose-copy">
      <h3 id="view-compose-title">See Henry through your own lens</h3>
      <p>Describe a question, theme, or perspective. Use AI to connect the relevant pieces and turn them into a focused <AiViewTerm />.</p>
    </div>
    <div class="view-compose-actions">
      <button type="button" class="compose-action" @click="openComposer">
        <span>Compose a <AiViewTerm /></span><ArrowUpRightIcon />
      </button>
      <router-link class="public-views-link" to="/views">
        <span>Explore public <AiViewTerm plural /></span><ArrowUpRightIcon />
      </router-link>
    </div>
  </section>
</template>

<script>
import AiViewTerm from '../ui/AiViewTerm.vue';
import ArrowUpRightIcon from '../ui/ArrowUpRightIcon.vue';

export default {
  name: 'ViewComposeInvitation',
  components: { AiViewTerm, ArrowUpRightIcon },
  methods: {
    openComposer() {
      window.dispatchEvent(new CustomEvent('open-site-view'));
    },
  },
};
</script>

<style scoped>
.view-compose-invitation {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 1.5rem;
  margin: 1.3rem 0 2.4rem;
  padding: 1rem 1.05rem;
  background: rgba(var(--site-accent-rgb), 0.065);
  color: #343434;
}

.view-compose-copy > span {
  color: var(--site-accent);
  font: 600 0.67rem/1.2 "Quattrocento Sans", sans-serif;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

.view-compose-copy h3 {
  margin: 0.38rem 0 0;
  font-size: 1.05rem;
  letter-spacing: normal;
}

.view-compose-copy p {
  margin: 0.42rem 0 0;
  color: #777;
  font: 0.78rem/1.5 "Quattrocento Sans", sans-serif;
}

.view-compose-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.58rem;
}

.compose-action,
.public-views-link {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  border: 0;
  border-radius: 0;
  color: inherit;
  font: 600 0.76rem/1 "Quattrocento Sans", sans-serif;
  text-decoration: none;
  cursor: pointer;
}

.compose-action {
  padding: 0.62rem 0.72rem;
  background: rgba(var(--site-accent-rgb), 0.14);
  transition: background-color 160ms ease, transform 100ms ease-out;
}

.public-views-link {
  position: relative;
  padding: 0.38rem 0.16rem 0.34rem;
  background: transparent;
}

.public-views-link::after {
  position: absolute;
  right: 0.16rem;
  bottom: 0;
  left: 0.16rem;
  height: 1px;
  background: currentColor;
  content: '';
  opacity: 0.2;
  transform: scaleX(0.28);
  transform-origin: left;
  transition: opacity 160ms ease, transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.compose-action .site-arrow-up-right,
.public-views-link .site-arrow-up-right {
  color: var(--site-accent);
  transition: transform 160ms ease;
}

.compose-action:hover,
.compose-action:focus-visible {
  background: rgba(var(--site-accent-rgb), 0.23);
}

.public-views-link:hover::after,
.public-views-link:focus-visible::after {
  opacity: 0.52;
  transform: scaleX(1);
}

.compose-action:hover .site-arrow-up-right,
.compose-action:focus-visible .site-arrow-up-right,
.public-views-link:hover .site-arrow-up-right,
.public-views-link:focus-visible .site-arrow-up-right {
  transform: translate(2px, -2px);
}

.compose-action:focus-visible,
.public-views-link:focus-visible {
  outline: 1px solid currentColor;
  outline-offset: 3px;
}

.compose-action:active {
  transform: scale(0.98);
}

body.dark-mode .view-compose-invitation {
  background: rgba(var(--site-accent-rgb), 0.075);
  color: #dedede;
}

body.dark-mode .view-compose-copy > span {
  color: var(--site-accent);
}

body.dark-mode .view-compose-copy p {
  color: #aaa;
}

body.dark-mode .compose-action {
  background: rgba(var(--site-accent-rgb), 0.15);
  color: #e2e2e2;
}

body.dark-mode .compose-action .site-arrow-up-right,
body.dark-mode .public-views-link .site-arrow-up-right {
  color: var(--site-accent);
}

body.dark-mode .compose-action:hover,
body.dark-mode .compose-action:focus-visible {
  background: rgba(var(--site-accent-rgb), 0.24);
}

body.dark-mode .public-views-link {
  color: #e2e2e2;
}

body.dark-mode .public-views-link:hover,
body.dark-mode .public-views-link:focus-visible {
  color: #f4f1ec;
}

@media (max-width: 700px) {
  .view-compose-invitation {
    grid-template-columns: 1fr;
    align-items: start;
  }

  .view-compose-actions,
  .compose-action,
  .public-views-link {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .compose-action,
  .public-views-link::after,
  .compose-action .site-arrow-up-right,
  .public-views-link .site-arrow-up-right {
    transition-duration: 0.01ms;
  }
}
</style>
